import {
  AnnotationListState,
  initialAnnotationListState,
} from '../../utils/annotation-list.state.abstract';

export type NoteListState = AnnotationListState;

export const initialNoteListState: NoteListState = {
  ...initialAnnotationListState,
};
